import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';

@Injectable()
export class TeamUsersService {
  responseData: any;
  handleError: any;

  constructor(private gtn: globals.GetTokenNow, private httpClient: HttpClient) {}

  createAgent(body) {
    return this.httpClient.post(`${globals.domain}/team/create-team-member/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  createCustomer(body) {
    return this.httpClient.post(`${globals.domain}/team/create-customer/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  viewAgent(profileId) {
    return this.httpClient.get(`${globals.domain}/team/profile/${profileId}/view/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateProfile(profileId, body) {
    return this.httpClient
      .put(`${globals.domain}/team/profile/${profileId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  listUsers(sort, records, pageNumber, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/team/list/users/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }
}